import { render, staticRenderFns } from "./InfinitePagination.vue?vue&type=template&id=6b02eec4&"
import script from "./InfinitePagination.vue?vue&type=script&lang=js&"
export * from "./InfinitePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports